export default __webpack_public_path__ + "static/pointCloud-a15b6a151c2b73dc37edd783f3e54e4f.gif";